interface MetaData {
  title: string;
  description: string;
  robots?: string;
  canonical?: string;
  og?: {
    locale?: string,
    type?: string,
    title?: string,
    description?: string,
    url?: string,
    site_name?: string,
    updated_time?: string,
    image?: string,
    image_secure_url?: string,
    image_width?: number,
    image_height?: number,
    image_alt?: string,
    image_type?: string,
    video?: string,
    video_duration?: number,
    video_upload_date?: string,
    video_allow_embed?: boolean,
  };
  twitter?: {
    card?: string,
    title?: string,
    description?: string,
    image?: string,
  };
}

interface Step {
  title: string;
  desc: string;
  icon: string;
}

interface ProcedureSteps {
  heading: string;
  para: string;
  steps: Step[];
}

interface ListItem {
  title: string;
  desc: string;
  icon: string;
}

interface ListSection {
  heading?: string;
  subheading?: string;
  para?: string;
  items: ListItem[];
}

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSection {
  heading?: string;
  subheading?: string;
  items: FAQItem[];
}

interface HeroSection {
  title: string;
  subtitle: string;
  description: string;
}

interface HowItWorks {
  title: string;
  description: string;
}

interface TreatmentArea {
  ar: string;
  title: string;
  image: string;
}

interface LanguageContent {
  url?: string; // Added url property
  meta: MetaData;
  breadcrumbs: string[];
  hero: HeroSection;
  howItWorks: HowItWorks;
  procedureSteps: ProcedureSteps;
  benefits: ListSection;
  eligibility: ListSection;
  preparationTips: ListSection;
  results: ListSection;
  aftercareTips: ListSection;
  faqData: FAQSection;
  treatmentAreas1: TreatmentArea[];
  treatmentAreas2: TreatmentArea[];
}

interface SharedData {
  images: {
    main: string,
    beforeAfter: string[] | any,
    introductionImage?: string,
  };
  product: {
    id: number,
    title: string,
    price: number,
    description: string,
  };
}

export const liposuction: {
  en: LanguageContent,
  ar: LanguageContent,
  shared: SharedData,
} = {
  "en": {
    "url": "liposuction-treatment",
    "meta": {
      "title": "Liposuction Treatment in Dubai - Elite Body Home",
      "description": "Everyone loves a strong fitness routine and strives to maintain a healthy lifestyle. However, due to change in the eating habits, excess fats may be a matter",
      "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
      "canonical": "https://elitebodyhome.com/services/liposuction-treatment-in-dubai/",
      "og": {
        "locale": "en_US",
        "type": "article",
        "title": "Liposuction Treatment in Dubai -",
        "description": "Everyone loves a strong fitness routine and strives to maintain a healthy lifestyle. However, due to change in the eating habits, excess fats may be a matter",
        "url": "https://elitebodyhome.com/services/liposuction-treatment-in-dubai/",
        "site_name": "elitebodyhome.com",
        "updated_time": "2025-01-23T09:27:39+00:00",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/EMS-Treatment-in-Dubaid.jpg",
        "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/EMS-Treatment-in-Dubaid.jpg",
        "image_width": 1254,
        "image_height": 700,
        "image_alt": "Liposuction Treatment in Dubai",
        "image_type": "image/jpeg"
      },
      "twitter": {
        "card": "summary_large_image",
        "title": "Liposuction Treatment in Dubai -",
        "description": "Everyone loves a strong fitness routine and strives to maintain a healthy lifestyle. However, due to change in the eating habits, excess fats may be a matter",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/EMS-Treatment-in-Dubaid.jpg"
      }
    },
    "breadcrumbs": ["Home", "Services", "Liposuction Treatment"],
    "hero": {
      "title": "Liposuction Treatment in Dubai",
      "subtitle": "Your Path to Confidence!",
      "description": "A healthy lifestyle is what people are after with a solid fitness regimen. But then again, with changing the eating habits, excess fats may be a concern. Stubborn fat pockets such as on thighs, belly, hips can be difficult to lose. We at Elite Body Home provides Liposuction treatment, which provides you with a balanced and well-contoured body shape and makes you look slimmer."
    },
    "howItWorks": {
      "title": "What is Liposuction?",
      "description": "Liposuction is a cosmetic surgery also known as liposculpture or fat removal surgery which helps remove localized fat deposits that do not respond to diet and the exercise. Some of the most common areas to have fat removed are: Upper Arms, Back, Inner and outer Thighs, Hips, Stomach, Face, Neck, & Chin"
    },
    "procedureSteps": {
      "heading": "Steps of liposuction treatment in Dubai",
      "para": "There are several steps to the liposuction procedure. Following them is crucial to achieve high-quality results.",
      "steps": [
        {
          "title": "Consultation",
          "desc": "Your treatment would start at Elite Body home when our dermatologist consults you and discusses the skin goals and concerns.",
          "icon": "fa-solid fa-comment-medical"
        },
        {
          "title": "Preparation",
          "desc": "We provide all the relevant information needed regarding the surgery, dietary modifications and more.",
          "icon": "fa-solid fa-clipboard-check"
        },
        {
          "title": "Anesthesia",
          "desc": "The operation is done with local anesthesia with sedation or general anesthesia. The cannula then use small incisions to extract fat deposits from the targeted regions.",
          "icon": "fa-solid fa-syringe"
        },
        {
          "title": "Healing",
          "desc": "Following the surgery, some swelling and bruising can be expected. Plus, we share all the tips for aftercare to make your job simple as well.",
          "icon": "fa-solid fa-heart-pulse"
        }
      ]
    },
    "benefits": {
      "heading": "Advantages of Liposuction Treatment",
      "subheading": "The best Liposuction treatment in Dubai has several benefits",
      "para": "The focus is on losing the excess fat your body is storing, not weight.",
      "items": [
        {
          "title": "Targeted Fat Reduction",
          "desc": "The primary advantage of liposuction Treatment in Dubai is, it removes fat that does not respond to exercise and diet.",
          "icon": "fa-solid fa-bullseye"
        },
        {
          "title": "A Good Body Shape",
          "desc": "The fatty body shape will never be a problem again. Going in this treatment, you've a totally characterized and balanced contour.",
          "icon": "fa-solid fa-user"
        },
        {
          "title": "Increase Your Confidence",
          "desc": "The shape of your body improves and eventually improves the structure of your personality esteem that raises your confidence.",
          "icon": "fa-solid fa-face-smile"
        },
        {
          "title": "Permanent Fat Removal",
          "desc": "Fat cells, once removed, don't return to the treated area.",
          "icon": "fa-solid fa-infinity"
        }
      ]
    },
    "eligibility": {
      "heading": "Who Is the Best Candidate for Liposuction Treatment in Dubai",
      "subheading": "Ideal candidates for liposuction",
      "para": "Not all persons are ideal to have the liposuction treatment. Ideal candidates are those people with resistant fat who are otherwise healthy and do not respond to exercise or diet.",
      "items": [
        {
          "title": "Stubborn Fat",
          "desc": "To put it simply, despite following a healthy, balanced diet and exercising regularly, there are certain areas that still have fat deposits and do not go away naturally. Example: belly, thighs, etc.",
          "icon": "fa-solid fa-weight-scale"
        },
        {
          "title": "Constant Weight",
          "desc": "Because your BMI means that you must be within 10% of your body weight. Liposuction is not a weight loss surgery l; l, but it encourages you to be in better shape after surgery.",
          "icon": "fa-solid fa-chart-line"
        },
        {
          "title": "Realistic Expectations",
          "desc": "Liposuction treatment is beneficial in enhancing confidence but it is very important to maintain realistic expectations.",
          "icon": "fa-solid fa-clipboard-check"
        }
      ]
    },
    "preparationTips": {
      "heading": "Preparing For Liposuction Treatment",
      "subheading": "What to expect before your procedure",
      "para": "Liposuction can also be major surgery or minimally invasive. That depends on the body area and the volume of fat to be removed. Based on the type of surgery you have, the preparation and recovery plan differ.",
      "items": [
        {
          "title": "Medication Adjustment",
          "desc": "Some of your medications, whether prescribed, over-the-counter or supplements, may need to be discontinued. They include blood thinners, NSAIDs (non-steroidal anti-inflammatory drugs), etc.",
          "icon": "fa-solid fa-pills"
        },
        {
          "title": "Avoid Smoking and Alcohol",
          "desc": "You'll also need to stop smoking and drinking alcohol for a minimum of two weeks before liposuction.",
          "icon": "fa-solid fa-smoking-ban"
        },
        {
          "title": "Medical Tests",
          "desc": "Imaging tests may also be done and the areas of interest may be marked with a temporary marker that will be used during your procedure.",
          "icon": "fa-solid fa-flask"
        },
        {
          "title": "Fasting",
          "desc": "You may need to fast for a certain period before the procedure if general anesthesia is used.",
          "icon": "fa-solid fa-utensils"
        }
      ]
    },
    "results": {
      "heading": "Results",
      "subheading": "What to expect after liposuction",
      "para": "Liposuction offers significant improvements in body contouring when combined with a healthy lifestyle.",
      "items": [
        {
          "title": "Improved Body Contour",
          "desc": "More defined shape with reduced fat deposits in treated areas.",
          "icon": "fa-solid fa-user"
        },
        {
          "title": "Permanent Fat Removal",
          "desc": "The removed fat cells do not grow back in the treated areas.",
          "icon": "fa-solid fa-check"
        },
        {
          "title": "Gradual Results",
          "desc": "Final results become visible after swelling subsides, typically within 3-6 months.",
          "icon": "fa-solid fa-clock"
        },
        {
          "title": "Boosted Confidence",
          "desc": "Improved body shape leads to enhanced self-esteem and confidence.",
          "icon": "fa-solid fa-face-laugh-beam"
        }
      ]
    },
    "aftercareTips": {
      "heading": "Liposuction Surgery Recovery Tips",
      "subheading": "Essential aftercare instructions",
      "para": "Just like the pre surgery instructions are a must, so are the after care tips. Here are a few of them to guarantee the best recovery.",
      "items": [
        {
          "title": "Avoid Pressure on Treated Areas",
          "desc": "Do not apply pressure to treated areas.",
          "icon": "fa-solid fa-hand-paper"
        },
        {
          "title": "Stay Hydrated",
          "desc": "Stay hydrated.",
          "icon": "fa-solid fa-glass-water"
        },
        {
          "title": "Take Medications as Directed",
          "desc": "That includes taking prescribed pain medication and antibiotics as directed.",
          "icon": "fa-solid fa-pills"
        },
        {
          "title": "Gentle Massage",
          "desc": "Gently massage lymphatic regions to help minimize fluid retention.",
          "icon": "fa-solid fa-hands"
        },
        {
          "title": "Wear Compression Garments",
          "desc": "Follow for your doctor directions as to when and for how long to wear compression garments",
          "icon": "fa-solid fa-shirt"
        },
        {
          "title": "Get Enough Rest",
          "desc": "Get enough rest and recommended sleep positioning.",
          "icon": "fa-solid fa-bed"
        },
        {
          "title": "Avoid Certain Substances",
          "desc": "Avoid smoking, alcohol and blood-thinning medications for a few weeks.",
          "icon": "fa-solid fa-ban"
        },
        {
          "title": "Monitor for Complications",
          "desc": "If you experience any symptoms that don't seem quite right, contact your surgeon.",
          "icon": "fa-solid fa-eye"
        }
      ]
    },
    "faqData": {
      "heading": "Frequently Asked Questions",
      "subheading": "Common questions about liposuction",
      "items": [
        {
          "question": "Is liposuction a weight loss method?",
          "answer": "No, liposuction is not intended for weight loss but rather for body contouring and reshaping areas that don't respond to diet or exercise."
        },
        {
          "question": "How long do liposuction results last?",
          "answer": "Results in the treated areas are permanent because fat cells are completely removed. However, maintaining a stable weight and healthy lifestyle is important as remaining fat cells can still expand with weight gain."
        },
        {
          "question": "Can fat return after liposuction?",
          "answer": "No, fat cells removed during liposuction don't grow back. However, you can still gain weight in other untreated areas if you don't maintain a healthy lifestyle."
        },
        {
          "question": "When will I see results?",
          "answer": "Initial results may be visible after a few weeks once swelling decreases, with final results typically appearing within 3-6 months after complete healing."
        },
        {
          "question": "How much weight can I lose with liposuction?",
          "answer": "The amount of weight loss varies based on individual goals, treated areas, and amount of fat removed. It's not primarily a weight loss procedure."
        },
        {
          "question": "What's the recovery time?",
          "answer": "Most patients can return to light activities within a few days, with full recovery taking several weeks. Strenuous activities should be avoided for about 4-6 weeks."
        }
      ]
    },
    "treatmentAreas1": [
      {
        "ar": "الذراعين",
        "title": "Upper Arms",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/arms-lipo.jpg"
      },
      {
        "ar": "الظهر",
        "title": "Back",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/back-lipo.jpg"
      },
      {
        "ar": "الفخذين",
        "title": "Thighs",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/thighs-lipo.jpg"
      }
    ],
    "treatmentAreas2": [
      {
        "ar": "الوركين",
        "title": "Hips",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/hips-lipo.jpg"
      },
      {
        "ar": "البطن",
        "title": "Stomach",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/stomach-lipo.jpg"
      },
      {
        "ar": "الوجه والرقبة والذقن",
        "title": "Face, Neck & Chin",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/face-lipo.jpg"
      }
    ]
  },
  "ar": {
    "url": "liposuction-treatment",
    "meta": {
      "title": "علاج شفط الدهون في دبي | ايليت بودي هوم",
      "description": "يسعى الجميع إلى الحفاظ على أسلوب حياة صحي من خلال ممارسة التمارين الرياضية بانتظام، ولكن تغير العادات الغذائية قد يؤدي إلى تراكم الدهون الزائدة، مما يشكّل مصدرًا للقلق للكثيرين.",
      "robots": "index, follow",
      "canonical": "https://elitebodyhome.com/services/liposuction-treatment-in-dubai/",
      "og": {
        "title": "علاج شفط الدهون في دبي | ايليت بودي هوم",
        "description": "يسعى الجميع إلى الحفاظ على أسلوب حياة صحي من خلال ممارسة التمارين الرياضية بانتظام، ولكن تغير العادات الغذائية قد يؤدي إلى تراكم الدهون الزائدة، مما يشكّل مصدرًا للقلق للكثيرين.",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/EMS-Treatment-in-Dubaid.jpg"
      }
    },
    "breadcrumbs": ["الرئيسية", "الخدمات", "علاج شفط الدهون"],
    "hero": {
      "title": "علاج شفط الدهون في دبي",
      "subtitle": "طريقتك المثلى للثقة بالنفس!",
      "description": "يسعى الجميع إلى الحفاظ على أسلوب حياة صحي من خلال ممارسة التمارين الرياضية بانتظام، ولكن تغير العادات الغذائية قد يؤدي إلى تراكم الدهون الزائدة، مما يشكّل مصدرًا للقلق للكثيرين. إضافة إلى ذلك، فإن مناطق تراكم الدهون العنيدة مثل الفخذين، والبطن، والوركين، قد يكون من الصعب التخلص من الدهون فيها بسهولة. نقدم لك في ايليت بودي هوم علاج شفط الدهون الذي سيساعدك على إزالة الدهون وتحقيق جسم متناسق ومتوازن، مما يمنحك مظهرًا أكثر رشاقة وجاذبية."
    },
    "howItWorks": {
      "title": "ما هو علاج شفط الدهون؟",
      "description": "يُعرف شفط الدهون باسم نحت الدهون أو جراحة إزالة الدهون أيضًا، وهو إجراء تجميلي يهدف إلى إزالة الخلايا الدهنية التي لا تستجيب للحمية الغذائية أو التمارين الرياضية ونحت الجسم. أكثر المناطق شيوعًا لشفط الدهون: الذراعين، الظهر، الفخذين (الجزء الداخلي والخارجي)، الوركين، البطن، الوجه، والرقبة، والذقن"
    },
    "procedureSteps": {
      "heading": "خطوات علاج شفط الدهون في دبي",
      "para": "يُجرى شفط الدهون من خلال عدة مراحل، ومن الضروري اتباعها بدقة للحصول على نتائج مثالية ومظهر متناسق.",
      "steps": [
        {
          "title": "الاستشارة",
          "desc": "تبدأ رحلتك في ايليت بودي هوم بجلسة استشارية مع طبيب الجلدية، حيث تُناقش أهدافك التجميلية والمناطق المستهدفة للعلاج.",
          "icon": "fa-solid fa-comment-medical"
        },
        {
          "title": "الاستعداد",
          "desc": "نوفر لك جميع التفاصيل اللازمة حول الإجراء، والتغييرات الغذائية المطلوبة، والتعليمات الأساسية لضمان تجربة آمنة وفعالة.",
          "icon": "fa-solid fa-clipboard-check"
        },
        {
          "title": "التخدير",
          "desc": "تُجرى العملية تحت التخدير الموضعي مع مهدئ أو التخدير العام. تُفتح خلال العملية فتحات صغيرة في المنطقة المُعالجة لإدخال قُنية رفيعة تعمل على إزالة الدهون.",
          "icon": "fa-solid fa-syringe"
        },
        {
          "title": "التعافي",
          "desc": "يمكن أن تعاني من بعض التورم والكدمات المؤقتة بعد الجراحة. لذا، نقدم لك إرشادات العناية بعد العملية لضمان شفاء سريع ونتائج دائمة.",
          "icon": "fa-solid fa-heart-pulse"
        }
      ]
    },
    "benefits": {
      "heading": "مزايا علاج شفط الدهون",
      "subheading": "يتميز علاج شفط الدهون في دبي بالعديد من المزايا",
      "para": "حيث يهدف إلى إزالة الدهون الزائدة بدلاً من مجرد فقدان الوزن. ومن هذه المزايا:",
      "items": [
        {
          "title": "التخلص من الدهون المستهدفة",
          "desc": "تُعد إحدى أهم مزايا شفط الدهون هي إزالة الدهون التي لا تستجيب للرياضة والحمية الغذائية.",
          "icon": "fa-solid fa-bullseye"
        },
        {
          "title": "تحسين شكل الجسم",
          "desc": "لا داعي للقلق بعد الآن بشأن تراكم الدهون، فسيساعدك شفط الدهون في تحقيق قوام متناسق ومحدد.",
          "icon": "fa-solid fa-user"
        },
        {
          "title": "تعزيز الثقة بالنفس",
          "desc": "ستشعر بارتفاع في مستوى ثقتك بنفسك مع تحسن شكل الجسم، مما ينعكس إيجابيًا على حياتك اليومية.",
          "icon": "fa-solid fa-face-smile"
        },
        {
          "title": "التخلص من الدهون للأبد",
          "desc": "بمجرد إزالة الخلايا الدهنية من المنطقة المعالجة، لا تعود مجددًا.",
          "icon": "fa-solid fa-infinity"
        }
      ]
    },
    "eligibility": {
      "heading": "المرشحون المثاليون لعملية شفط الدهون في دبي",
      "subheading": "معايير المرشح المثالي",
      "para": "لا يلائم علاج شفط الدهون الجميع، حيث يناسب الأشخاص الأصحاء الذين يعانون من تراكمات دهنية لا تستجيب للرياضة أو الحمية الغذائية.",
      "items": [
        {
          "title": "تواجد دهون عنيدة",
          "desc": "تبقي بعض الدهون متراكمة في مناطق معينة مثل البطن والفخذين باللرغم من اتباع نظام غذائي صحي وممارسة التمارين الرياضية.",
          "icon": "fa-solid fa-weight-scale"
        },
        {
          "title": "ثبات الوزن",
          "desc": "يُعد من المهم أن يكون مؤشر كتلة الجسم (BMI) ضمن النطاق الصحي وألا يتجاوز الوزن المثالي بأكثر من 10%، إذ أن شفط الدهون ليس عملية لإنقاص الوزن، ولكنه يساعد في ذلك عند اتباع نمط حياة صحي بعد الجراحة.",
          "icon": "fa-solid fa-chart-line"
        },
        {
          "title": "توقعات واقعية",
          "desc": "يعزز شفط الدهون الثقة بالنفس ويحسن تناسق الجسم، ومع ذلك من الضروري أن يكون لدى الشخص توقعات واقعية حول النتائج المحتملة.",
          "icon": "fa-solid fa-clipboard-check"
        }
      ]
    },
    "preparationTips": {
      "heading": "الاستعداد لعملية شفط الدهون",
      "subheading": "ما يمكن توقعه قبل الجراحة",
      "para": "يمكن أن تكون عملية شفط الدهون جراحة كبرى أو إجراء طفيف، يعتمد ذلك على المنطقة المستهدفة وكمية الدهون المراد إزالتها، ولذلك يختلف الاستعداد وخطة التعافي تبعًا لنوع الجراحة.",
      "items": [
        {
          "title": "إيقاف بعض الأدوية",
          "desc": "قد تحتاج إلى إيقاف بعض الأدوية، سواء كانت وصفات طبية أو مكملات غذائية، وتشمل مميعات الدم، ومضادات الالتهاب غير الستيرويدية (NSAIDs)، وأدوية أخرى.",
          "icon": "fa-solid fa-pills"
        },
        {
          "title": "التوقف عن التدخين والكحول",
          "desc": "يجب التوقف عن التدخين وشرب الكحول لمدة لا تقل عن أسبوعين قبل الخضوع للعملية.",
          "icon": "fa-solid fa-smoking-ban"
        },
        {
          "title": "الفحوصات التصويرية",
          "desc": "قد يقوم الطبيب بإجراء فحوصات تصويرية وتحديد المناطق المستهدفة باستخدام علامات مؤقتة قبل العملية لتكون مرجعًا أثناء الإجراء.",
          "icon": "fa-solid fa-flask"
        },
        {
          "title": "الصيام قبل الجراحة",
          "desc": "قد يُطلب منك الصيام لفترة معينة قبل العملية إذا تم استخدام التخدير العام.",
          "icon": "fa-solid fa-utensils"
        }
      ]
    },
    "results": {
      "heading": "النتائج",
      "subheading": "ما يمكن توقعه بعد الجراحة",
      "para": "يقدم شفط الدهون تحسينات كبيرة في نحت الجسم عند دمجه مع نمط حياة صحي.",
      "items": [
        {
          "title": "تحسين ملامح الجسم",
          "desc": "شكل أكثر تحديدًا مع تقليل تراكم الدهون في المناطق المعالجة.",
          "icon": "fa-solid fa-user"
        },
        {
          "title": "إزالة دائمة للدهون",
          "desc": "لا تنمو الخلايا الدهنية التي تمت إزالتها مرة أخرى في المناطق المعالجة.",
          "icon": "fa-solid fa-check"
        },
        {
          "title": "نتائج تدريجية",
          "desc": "تظهر النتائج النهائية بعد زوال التورم، عادة خلال 3-6 أشهر.",
          "icon": "fa-solid fa-clock"
        },
        {
          "title": "تعزيز الثقة بالنفس",
          "desc": "تحسن شكل الجسم يؤدي إلى تعزيز احترام الذات والثقة.",
          "icon": "fa-solid fa-face-laugh-beam"
        }
      ]
    },
    "aftercareTips": {
      "heading": "نصائح للتعافي بعد جراحة شفط الدهون",
      "subheading": "إرشادات العناية الأساسية بعد الجراحة",
      "para": "كما أن التحضير للعملية أمر ضروري، فإن الالتزام بتعليمات الرعاية بعد الجراحة لا يقل أهمية لضمان الشفاء السريع والحصول على أفضل النتائج.",
      "items": [
        {
          "title": "تجنب الضغط على المناطق المعالجة",
          "desc": "تجنب الضغط على المناطق المعالجة للحفاظ على نتائج العملية ولسرعة التعافي.",
          "icon": "fa-solid fa-hand-paper"
        },
        {
          "title": "الحفاظ على ترطيب الجسم",
          "desc": "احرص على شرب كميات كافية من الماء.",
          "icon": "fa-solid fa-glass-water"
        },
        {
          "title": "تناول الأدوية الموصوفة",
          "desc": "تناول مسكنات الألم والمضادات الحيوية الموصوفة وفقًا لتعليمات الطبيب.",
          "icon": "fa-solid fa-pills"
        },
        {
          "title": "التدليك اللطيف",
          "desc": "قم بتدليك المناطق اللمفاوية بلطف لتقليل احتباس السوائل والتورم.",
          "icon": "fa-solid fa-hands"
        },
        {
          "title": "ارتداء الملابس الضاغطة",
          "desc": "ارتدِ الملابس الضاغطة كما يوصي الطبيب.",
          "icon": "fa-solid fa-shirt"
        },
        {
          "title": "الحصول على الراحة الكافية",
          "desc": "احصل على قسط كافٍ من الراحة والتزم بوضعيات النوم الموصى بها.",
          "icon": "fa-solid fa-bed"
        },
        {
          "title": "تجنب بعض المواد",
          "desc": "امتنع عن التدخين، وشرب الكحول، وتناول الأدوية المسيلة للدم لعدة أسابيع بعد العملية.",
          "icon": "fa-solid fa-ban"
        },
        {
          "title": "مراقبة المضاعفات",
          "desc": "تواصل مع طبيبك فورًا إذا لاحظت أي أعراض غير طبيعية.",
          "icon": "fa-solid fa-eye"
        }
      ]
    },
    "faqData": {
      "heading": "الأسئلة الشائعة حول عملية شفط الدهون",
      "subheading": "أسئلة شائعة",
      "items": [
        {
          "question": "هل عملية شفط الدهون وسيلة لإنقاص الوزن؟",
          "answer": "لا، لا تهدف عملية شفط الدهون لإنقاص الوزن، بل هو إجراء يهدف إلى نحت الجسم وإعادة تشكيل المناطق التي لا تستجيب للنظام الغذائي أو التمارين الرياضية."
        },
        {
          "question": "ما مدة استمرار نتائج شفط الدهون؟",
          "answer": "تدوم نتائج شفط الدهون للمناطق المُعالجة لأن الخلايا الدهنية تُزال نهائيًا. ومع ذلك، يجب الحفاظ على وزن مستقر ونمط حياة صحي، لأن زيادة الوزن قد تؤدي إلى تضخم الخلايا الدهنية المتبقية في مناطق أخرى من الجسم."
        },
        {
          "question": "هل يمكن أن تعود الدهون بعد شفط الدهون؟",
          "answer": "لا، حيث يتم إزالة الخلايا الدهنية نهائيًا من المناطق المعالجة، ومع ذلك يمكن تراكم الدهون في مناطق أخرى غير المعالجة في حال اكتساب وزن زائد، لذلك يُعد ممارسة التمارين الرياضية بانتظام واتباع نظام غذائي متوازن أمرًا أساسيًا للحفاظ على النتائج."
        },
        {
          "question": "متي تظهر نتائج شفط الدهون؟",
          "answer": "قد تبدأ النتائج الأولية في الظهور بعد بضعة أسابيع، بمجرد أن يخف التورم، بينما يمكن ملاحظة النتائج النهائية في غضون 3 إلى 6 أشهر بعد الجراحة بمجرد أن يتعافى الجسم بالكامل."
        },
        {
          "question": "كم من الوزن يمكن فقدانه بعد شفط الدهون؟",
          "answer": "تختلف كمية الوزن المفقود بعد شفط الدهون حسب أهدافك الشخصية، والمنطقة المُعالجة، وكمية الدهون التي أُزيلت."
        },
        {
          "question": "ما هي مدة التعافي؟",
          "answer": "يمكن لمعظم المرضى العودة إلى الأنشطة الخفيفة خلال بضعة أيام، مع اكتمال التعافي خلال عدة أسابيع. يجب تجنب الأنشطة الشاقة لمدة 4-6 أسابيع."
        }
      ]
    },
    "treatmentAreas1": [
      {
        "ar": "الذراعين",
        "title": "الذراعين",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/arms-lipo.jpg"
      },
      {
        "ar": "الظهر",
        "title": "الظهر",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/back-lipo.jpg"
      },
      {
        "ar": "الفخذين",
        "title": "الفخذين",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/thighs-lipo.jpg"
      }
    ],
    "treatmentAreas2": [
      {
        "ar": "الوركين",
        "title": "الوركين",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/hips-lipo.jpg"
      },
      {
        "ar": "البطن",
        "title": "البطن",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/stomach-lipo.jpg"
      },
      {
        "ar": "الوجه والرقبة والذقن",
        "title": "الوجه والرقبة والذقن",
        "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/face-lipo.jpg"
      }
    ]
  },
  "shared": {
    "images": {
      "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/EMS-Treatment-in-Dubaid.jpg",
      "beforeAfter": [
        {
          "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/liposuction-before-after-1.jpg",
          "alt": "Liposuction before and after results"
        },
        {
          "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/liposuction-before-after-2.jpg",
          "alt": "Liposuction before and after results"
        },
        {
          "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/liposuction-before-after-3.jpg",
          "alt": "Liposuction before and after results"
        }
      ]
    },
    "product": {
      "id": 165,
      "title": "Liposuction Treatment in Dubai",
      "description": "Surgical fat removal procedure to contour and reshape specific areas of the body by removing stubborn fat deposits that don't respond to diet or exercise.",
      "price": 3000
    }
  }
}